import { type CheckoutReceipts, type Receipt } from '../types';
import {
  getCountry,
  getReceipts,
  type IncomingPayment,
  type IncomingPaymentStatus,
} from '@tectonics/prs/incoming-payment';
import { getInstalmentByEndUser } from '../getters';

export type ReceiptStrategy = {
  readonly matches: (context: {
    paymentStatus: IncomingPaymentStatus,
    selectedPaymentMethodCode: string,
  }) => boolean,
  readonly getReceipt: (context: {
    resolveReceipts: () => CheckoutReceipts,
    selectedInstalment: string,
    incomingPayment: IncomingPayment,
    selectedPaymentMethodCode: string,
  }) => Receipt | undefined,
};

export const VALID_STATUSES_FOR_FINAL_RECEIPT: ReadonlyArray<IncomingPaymentStatus> = ['PE', 'CO'];

export const ELIGIBLE_PAYMENT_METHODS_FOR_INSTALMENTS: ReadonlyArray<string> = ['creditcard', 'google'];

export const ELIGIBLE_PAYMENT_METHODS_FOR_BANKTRANSFER_AR: ReadonlyArray<string> = ['banktransfer'];

export const CRYPTOCURRENCY_PAYMENT_METHODS: ReadonlyArray<string> = ['cryptocurrency'];

export const getBanktransferReceiptForAR = (
  selectedPaymentMethodCode: string,
  incomingPayment: IncomingPayment,
  selectedInstalment: string,
): Receipt | undefined => {
  const country = getCountry(incomingPayment);

  const isEligibleForBanktransfer = ELIGIBLE_PAYMENT_METHODS_FOR_BANKTRANSFER_AR.includes(selectedPaymentMethodCode) && country === 'ar';

  if (isEligibleForBanktransfer) {
    const receipts = getReceipts(incomingPayment);
    const instalments = getInstalmentByEndUser(receipts, selectedPaymentMethodCode, country, Number(selectedInstalment));

    if (instalments) return instalments;
  }

  return undefined;
};
